import React from 'react';
import './ActionButton.css';

/**
 * Template-style action button (secondary + primary).
 * Matches Send Test Email / Reset default / Apply changes on email & SMS settings.
 */
const VARIANT_CLASS = {
  primary: 'app-action-btn--primary',
  info: 'app-action-btn--info',
  success: 'app-action-btn--success',
};

const ActionButton = ({
  children,
  variant = 'default',
  size = 'default',
  className = '',
  type = 'button',
  ...rest
}) => (
  <button
    type={type}
    className={[
      'app-action-btn',
      VARIANT_CLASS[variant],
      size === 'sm' && 'app-action-btn--sm',
      className,
    ]
      .filter(Boolean)
      .join(' ')}
    {...rest}
  >
    {children}
  </button>
);

export default ActionButton;
